import React, { useState } from 'react';
import { Link } from 'react-admin'
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import ShowIcon from '@material-ui/icons/Visibility';
import DataProvider from '../../DataProvider'
import useUser from '../../hooks/useUser';


export const ShowFromOrg = ({ record, orgID, buttonTitle, path, search_id }) => {
    return (
        <Button
            style={{ color: "#03a9f4" }}
            component={Link}
            to={{
                pathname: `/${path}/${record.id}/show`,
                search: `?${search_id}=${orgID}`,
            }}>
            {buttonTitle}
            <ShowIcon />
        </Button>
    );
}

//redirect after saving
export const EditCustomRedirectButton = props => {
    let search
    if (props.ddorgid) search = `?organization_id=${props.ddorgid}&redirect_origin=${props.redirectorigin}`
    else search = `?${props.search_id}=${props.orgID}&redirect_origin=${props.redirectorigin}`
    return (
        <Button
            style={{
                fontSize: '10',
                color: "#03a9f4",
            }}
            component={Link}
            to={{
                pathname: `/${props.path}/${props.record.id}/edit`,
                search: search,
            }}>
            Edit
            <EditIcon />
        </Button>
    );
}

export const BackToOrgButton = (props) => {
    const organization_id = props.organization_id
    return (organization_id && organization_id !== "undefined" ? <a style={{ color: "primary", fontFamily: "roboto", fontSize: "1.2em", fontWeight: "bold" }} href={`/Organizations/${organization_id}/show`} >{organization_id && 'Back to org'}</a> : <div />)
}

export const ShowOrgButton = (props) => {

    const user = useUser()
    const record = props.record
    const organization_id = record.org_id || record.organization_id || record.OrganizationId || null
    const [orgName, setOrgName] = useState('')

    async function renderData() {
        try {
            const data = await DataProvider.getOne('organizations', { id: organization_id })
            const orgName = data.data.name || `Missing org Name - id: ${organization_id} `
            setOrgName(orgName)
        } catch (e) {
            setOrgName(`Missing org Name - id: ${organization_id} `)
        }
    }

    if (organization_id)
        renderData()
    if (user.role !== "super-admin" && user.role !== "channel-admin") return <></>
    else if (orgName) {
        return <a style={{ color: '#03a9f4', fontFamily: "roboto", fontSize: "1.2em", fontWeight: "bold" }} href={`/Organizations/${organization_id}/show`} >{orgName}</a>
    } else {
        return <div>No Organization</div>
    }
}


export const ShowOrgListButton = (props) => {
    const record = props.record

    const organization_id = record.org_id || record.organization_id || record.OrganizationId || null
    const [orgName, setOrgName] = useState(null)

    async function renderData() {
        try {
            const data = await DataProvider.getOne('organizations', { id: organization_id })
            const orgName = data.data.name || `Missing org Name - id: ${organization_id} `
            setOrgName(orgName)
        } catch (e) {
            setOrgName(`Missing org Name - id: ${organization_id} `)
        }
    }

    if (organization_id && !orgName)
        renderData()

    if (orgName) {
        return <a style={{ color: '#03a9f4', fontFamily: "roboto" }} href={`/Organizations/${organization_id}/show`} >{orgName || ''}</a>
    } else if (!organization_id) {
        return <div style={{ fontFamily: "roboto" }}>No Organization</div>
    } else {
        return <div style={{ fontFamily: "roboto" }}>loading...</div>
    }
}

